/**
 * 기구 무대에 서는 기계인가(machine-stage · 2026-10-06) — 홈 타일 · 코스 미션 입장(정적 기계면 무대로)이 함께 쓴다.
 * features/stage 와 features/course 가 서로를 부르지 않게 lib 에 둔다.
 */
import { machineStage } from "@picnic-field/modes";

/** 기구 무대가 있는 기계 모형(놀이기구 · 오토마타 13종 — 저장소 모드 정의) */
export const STAGE_MODELS: ReadonlySet<string> = new Set(
  machineStage.presets.flatMap((p) => (p.stage ? [p.stage.model] : [])),
);
/** 내 기계가 무대 모형이거나 SPIKE 정적 기계(구동 바퀴 없음)인가 */
export const isStageMachine = (
  s: { modelSlug?: string | null; static?: boolean; board?: string | null } | null,
): boolean =>
  !!s && ((!!s.modelSlug && STAGE_MODELS.has(s.modelSlug)) || (!!s.static && s.board === "spike"));
